import styled from 'styled-components';
import { ScrollingText } from 'modules/ai/ui/animations/ScrollingText';
import { ProgressSpinner } from 'modules/ai/ui/animations/ProgressSpinner';
import { Body2, Caption, colors, spacing } from 'ui/theme';

const scrollingText = [
  'Adding your tiles...',
  'Making sure it’s all connected...',
  'Testing a few things...',
  'Adding a little magic...',
  'Gathering some things...',
];

const LoadingContainer = styled.div`
  display: flex;
  gap: ${spacing.threeQuarter};
  align-items: center;
`;

const StyledLoadingText = styled(Body2)`
  margin: 0;
`;

const StyledCaption = styled(Caption)`
  color: ${colors.textSecondary};
`;

export const Loading = () => {
  return (
    <LoadingContainer>
      <ProgressSpinner duration={40} />
      <div style={{ flex: 1 }}>
        <ScrollingText scrollingText={scrollingText} TextCmp={StyledLoadingText} />
        <StyledCaption>This may take up to a minute</StyledCaption>
      </div>
    </LoadingContainer>
  );
};
